import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { INavLink, isNavLinkActive } from '../Navigation.const'
import { NavIcon } from './NavIcon'
import { getNavItemClassName } from './NavItemClassName'
import { NavSubItemMarker } from './NavSubItemMarker'
import { NavTooltip } from './NavTooltip'

export interface INavMenuLinkProps {
  link: INavLink
  /** Вложенный пункт раскрытой группы — мельче и всегда с подписью */
  nested?: boolean
  /** Свёрнутое меню: только иконка, подпись уходит в тултип справа */
  collapsed?: boolean
  /** Пункт на светлой подложке — например, в поповере свёрнутого меню */
  light?: boolean
  onNavigate?: () => void
}

export const NavMenuLink = ({
  link,
  nested = false,
  collapsed = false,
  light = false,
  onNavigate,
}: INavMenuLinkProps) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const active = isNavLinkActive(link, pathname, nested)
  const label = t(link.label)

  return (
    <NavTooltip disabled={!collapsed} label={label}>
      <Link
        className={getNavItemClassName({ active, collapsed, light, nested })}
        to={link.to}
        onClick={onNavigate}
      >
        {nested ? (
          <NavSubItemMarker icon={link.icon} light={light} />
        ) : (
          link.icon && <NavIcon icon={link.icon} />
        )}
        <span className={clsx('truncate leading-[24px]', { ['hidden']: collapsed })}>{label}</span>
      </Link>
    </NavTooltip>
  )
}
